const messages = {
  email_placeholder: 'Please enter email address',
  email: 'Email',
  password_placeholder: 'Enter password',
  password: 'Password',
  invalid_email: 'Please enter valid email',
  invalid_password: 'Please enter valid password',
  login: 'Login',
  logout: 'Logout',
  cloud: 'cloud',
  statistics: 'Report',
  team: 'Team',
  role: 'Role',
  sitemap: 'Sitemap',
  setting: 'Setting',
  sidebar: 'Sidebar',
  pages: 'Pages',
  images: 'Images',
  icons: 'Icons',
  documents: 'Documents',
  profile: 'Profile',
  contract: 'Contract',
  about: 'About',
  partner: 'Partner',

  trash: 'TRASH',
  draft: 'DRAFT',
  finished: 'FINISHED',
  scheduled: 'SCHEDULED',
  published: 'PUBLISHED',
  deactivated: 'DEACTIVATED',
  unSaved: 'UNSAVED',

  list: 'LIST',
  competition: 'COMPETITION',
  statics: 'STATICS',

  editor: 'Editor',
  manager: 'Manager',
  sales: 'Sales',

  // judge tabs
  report: 'REPORT',
  people: 'PEOPLE',
  time: 'TIME',
  award: 'AWARD',
  candidate: 'CANDIDATE',
};

export default messages;
